import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { OfflineAgentListDTO } from '../../shared/models/offline-agent.model';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { AgentFilter } from '../../shared/models/offline-agent-filter.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Listing } from 'src/app/shared/models/listing.model';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationExtras } from '@angular/router';
import { AppConfig } from 'src/app/shared/services/app.config';
import { User } from 'src/app/front-user/shared/models/user.model';


@Component({
  selector: 'app-offline-agent-list',
  templateUrl: './offline-agent-list.component.html',
  styleUrls: ['./offline-agent-list.component.css']
})
export class OfflineAgentListComponent implements OnInit {
  private collection: Listing;
  pageSize = 10;
  private itemsMenu: MenuItem[] = [];
  agentFilter: AgentFilter = new AgentFilter();
  //#endregion
  @ViewChild('MyAgents',{static: false}) gridView: GridViewComponent;
  IsHtml: boolean = false;
  HasMenu: boolean = true;
  SearchForm: FormGroup;
  searchName: any = '';
  DomainUrl = AppConfig.settings.apiServer.DomainAdminUrl;
  public currentUser: User = new User();
  constructor(private adminSrv: RegistrationAdminService, private router: Router, private global: GlobalServices,
    private formBuilder: FormBuilder, private sanitized: DomSanitizer) { }

  ngOnInit() {

    this.currentUser = this.global.user;
    if (this.currentUser.IsAdmin) {
      this.buildForm();
    //Enable Loader
    this.global.isLoaderEnabled = true;
    this.loadMyTasks(0, "AgentName", "DESC");
     }
    else {
      this.router.navigateByUrl('/workspace');
    }
  }

  buildForm() {
    this.SearchForm = this.formBuilder.group({
      SearchName: new FormControl(''),
    });
  }

  loadMyTasks(pPageIndex: number, pSortBy: string, pSortDirection: string) {
    this.searchName = this.SearchForm.controls.SearchName.value;
    this.adminSrv.AgentList(pPageIndex, this.pageSize, this.searchName, pSortBy, pSortDirection).subscribe(
      data => {
        this.collection = data.Data,
          console.log("Something went wrong!!")
          this.loadCollectionCompleted(pSortBy, pSortDirection)
      },
    );
  }
  loadCollectionCompleted(pSortBy: string, pSortDirection: string) {

    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      "Agent/AgentList?pageIndex={PAGEINDEX}&pageSize=" + this.pageSize + '&searchName=' + this.searchName +
      "&sortBy={SORTBY}&sortDirection={SORTDIR}",
      "SHARED.MYTASKS", this.itemsMenu, pSortBy, pSortDirection, "AgentList");
    //Disable Loader
    this.global.isLoaderEnabled = false;
  }


  Activate(id:string){
    if (id) {
      window.open("#/activateAgent/"+id, '_blank');
    }
  }
  DeActivate(id:string){
    if (id) {
      window.open("#/deactivateAgent/"+id, '_blank');
    }
  }
  onSubmit() {

    this.global.isLoaderEnabled = true;
    this.searchName = this.SearchForm.value;
    this.loadMyTasks(0, "AgentName", "DESC");;
  }

  reset() {
    this.SearchForm.controls.SearchName.setValue("");
    this.searchName = "";
  }

  Details(requestId){
    const navigationExtras: NavigationExtras = {state: { data: { requestId}}};
    this.router.navigate(['/register'], navigationExtras);
  }
}


export class MenuItem {
  Title: string;
  TitleAr: string;
};

export enum AgentStatus {
  InActive = "InActive",
  Active = "Active"
};
export enum AgentSource {
  Offline = "Offline",
  Online = "Online"
};
